import { HttpContextToken } from '@angular/common/http';

/**
 * HTTP 요청에 로그 내용을 첨부하기 위한 HttpContextToken입니다.
 * 이 토큰을 사용하여 요청의 목적이나 컨텍스트를 서버 로그에 기록할 수 있습니다.
 *
 * @example
 * const context = new HttpContext().set(LOG_CONTENT, '[엑셀 다운로드] 회원_목록');
 * this.service.search(params, context);
 */
export const LOG_CONTENT = new HttpContextToken<string>(() => '');
